<template>
  <el-row class="full" v-if="!yunModel">
    <div class="main">
      <div class="main-container">
        <el-col :span="6" class="col-section-1">
          <div class="item fl">
            <img v-lazy="'//doc.yctop.com/yc/static/images/yc-wx-code.jpg'" />
            <p>{{ $t("side.public") }}</p>
          </div>
          <div class="item fl">
            <img
              v-lazy="'//doc.yctop.com/yc/static/images/yc-we-app-code.jpg'"
            />
            <p>{{ $t("side.weapp") }}</p>
          </div>
        </el-col>
        <el-col :span="9" class="col-section-2">
          <div class="item title">
            {{ $t("footer.why") }}
          </div>
          <div class="item">
            <a href="/#section-2">{{ $t("footer.reason1") }}</a>
          </div>
          <div class="item">
            <a href="/#section-3">{{ $t("footer.reason2") }}</a>
          </div>
          <div class="item">
            <a href="/#section-4">{{ $t("footer.reason3") }}</a>
          </div>
          <div class="item">
            <a href="/#section-5">{{ $t("footer.reason4") }}</a>
          </div>
          <div class="item">
            <a href="/#section-6">{{ $t("footer.reason5") }}</a>
          </div>
        </el-col>
        <el-col :span="3" class="col-section-2">
          <div class="item title">
            {{ $t("header.menu.product") }}
          </div>
          <div class="item">
            <router-link :to="{ name: 'ProductQueryPage' }">{{
              $t("home.International")
            }}</router-link>
          </div>
        </el-col>
        <el-col :span="3" class="col-section-2">
          <div class="item title">
            {{ $t("header.menu.tool") }}
          </div>
          <div class="item">
            <router-link to="/tool/airport_code">{{
              $t("header.menu.airportCode")
            }}</router-link>
          </div>
          <div class="item">
            <router-link to="/tool/hs_code">{{
              $t("header.menu.hs")
            }}</router-link>
          </div>
          <div class="item">
            <router-link to="/tool/tact">{{
              $t("header.menu.tact")
            }}</router-link>
          </div>
          <div class="item">
            <router-link to="/tool/airline_info">{{
              $t("header.menu.airlineInfo")
            }}</router-link>
          </div>
          <div class="item">
            <router-link to="/tool/plane_type">{{
              $t("header.menu.planeType")
            }}</router-link>
          </div>
          <div class="item">
            <router-link :to="{ name: 'TrackPage' }">{{
              $t("header.menu.track")
            }}</router-link>
          </div>
        </el-col>
        <el-col :span="2" class="col-section-2 col-sec-3">
          <div class="item title">
            {{ $t("header.menu.sales") }}
          </div>
          <div class="item">
            <router-link to="/product/starList">{{
              $t("footer.sales")
            }}</router-link>
          </div>
        </el-col>
        <el-col :span="1" class="col-section-2 col-sec-4">
          <div class="item title">
            {{ $t("header.menu.about") }}
          </div>
          <div class="item">
            <router-link to="/yc">{{ $t("footer.intro") }}</router-link>
          </div>
        </el-col>
      </div>
    </div>
    <div class="sub main-container">
      <div class="desc">
        copyright& #169 2011-2019 yctop.com &nbsp;<a
          href="http://www.beian.miit.gov.cn/"
          style="color: rgb(168, 172, 185);"
          > {{ $t("footer.copyright2") }}</a
        >{{ $t("footer.copyright") }}
      </div>
    </div>
  </el-row>
  <div v-else></div>
</template>
<script>
window._pt_lt = new Date().getTime();
window._pt_sp_2 = [];
_pt_sp_2.push("setAccount,36e7bab5");
var _protocol =
  "https:" == document.location.protocol ? " https://" : " http://";
(function() {
  var atag = document.createElement("script");
  atag.type = "text/javascript";
  atag.async = true;
  atag.src = _protocol + "js.ptengine.cn/36e7bab5.js";
  var s = document.getElementsByTagName("script")[0];
  s.parentNode.insertBefore(atag, s);
})();

var _hmt = _hmt || [];
(function() {
  var domain = window.location.host;
  if (domain == "www.yctop.com" || domain == "yctop.com") {
    var hm = document.createElement("script");
    hm.src = "https://hm.baidu.com/hm.js?48d80e3746378427ef02927722a06afc";
    var s = document.getElementsByTagName("script")[0];
    s.parentNode.insertBefore(hm, s);
  }
})();

export default {
  data: function() {
    return {
      yunModel: this.$route.meta.yunModel
    };
  }
};
</script>
<style scoped>
@import "./index.css";
</style>
